function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useLayoutEffect } from 'react';
import { transaction } from 'mobx';
// eslint-disable-next-line import/no-unresolved -- mobx-react-lite is a phantom dep provided by consuming apps
import { useObserver } from 'mobx-react-lite';
import _ from 'lodash';
import useStores from 'shared/hooks/use-stores';
import useApolloQuery from 'shared/hooks/use-apollo-query';
import getRewardsV2 from 'shared/graphql/reward/queries/get-rewards-V2.gql';
import isMobilePhone from 'validator/lib/isMobilePhone';
import { formatBirthdayForRewards, getAiqSmsPinTriggerDecision, rewardsProgramEnabled } from 'shared/helpers/rewards';
// eslint-disable-next-line import/no-unresolved -- launchdarkly-react-client-sdk is a phantom dep provided by consuming apps
import { useFlags } from 'launchdarkly-react-client-sdk';
export default function useCheckForRewards(phoneParam, dobParam) {
    var _User_profile, _User_profile1, _Cart_order_dispensary_consumerDispensaryIntegrations_alpineiq, _Cart_order_dispensary_consumerDispensaryIntegrations, _Cart_order_dispensary, _Cart_order, _Cart_order_dispensary_consumerDispensaryIntegrations_dutchieposloyalty, _Cart_order_dispensary_consumerDispensaryIntegrations1, _Cart_order_dispensary1, _Cart_order_dispensary2, _Cart_order1, _Cart_rewardAuth, _Cart_getAutomaticAiqOneShotContext, _data_getRewardsV2;
    var _useStores = useStores(), User = _useStores.User, Cart = _useStores.Cart, UI = _useStores.UI;
    var flags = useFlags();
    var _flags_poscustomersaiqsmspintriggersettingrollout;
    // Staged migration off the legacy pos.customers.skip-sms-sending.rollout flag (POS-21141).
    // Once pos.customers.aiq-sms-pin-trigger-setting.rollout is on for this dispensary, the
    // dispensary's own aiqSmsPinTriggerBehavior setting takes over; until then this preserves
    // today's behavior exactly.
    var isAiqSmsPinTriggerSettingEnabled = (_flags_poscustomersaiqsmspintriggersettingrollout = flags['pos.customers.aiq-sms-pin-trigger-setting.rollout']) !== null && _flags_poscustomersaiqsmspintriggersettingrollout !== void 0 ? _flags_poscustomersaiqsmspintriggersettingrollout : false;
    var _flags_poscustomersskipsmssendingrollout;
    var isSkipSMSSendingEnabled = (_flags_poscustomersskipsmssendingrollout = flags['pos.customers.skip-sms-sending.rollout']) !== null && _flags_poscustomersskipsmssendingrollout !== void 0 ? _flags_poscustomersskipsmssendingrollout : false;
    var phoneNumber = phoneParam || ((_User_profile = User.profile) === null || _User_profile === void 0 ? void 0 : _User_profile.phone) || '';
    var dob = formatBirthdayForRewards(dobParam || ((_User_profile1 = User.profile) === null || _User_profile1 === void 0 ? void 0 : _User_profile1.birthday) || '');
    var _Cart_order_dispensary_consumerDispensaryIntegrations_alpineiq_enabled;
    var isAlpineIQEnabled = (_Cart_order_dispensary_consumerDispensaryIntegrations_alpineiq_enabled = (_Cart_order = Cart.order) === null || _Cart_order === void 0 ? void 0 : (_Cart_order_dispensary = _Cart_order.dispensary) === null || _Cart_order_dispensary === void 0 ? void 0 : (_Cart_order_dispensary_consumerDispensaryIntegrations = _Cart_order_dispensary.consumerDispensaryIntegrations) === null || _Cart_order_dispensary_consumerDispensaryIntegrations === void 0 ? void 0 : (_Cart_order_dispensary_consumerDispensaryIntegrations_alpineiq = _Cart_order_dispensary_consumerDispensaryIntegrations.alpineiq) === null || _Cart_order_dispensary_consumerDispensaryIntegrations_alpineiq === void 0 ? void 0 : _Cart_order_dispensary_consumerDispensaryIntegrations_alpineiq.enabled) !== null && _Cart_order_dispensary_consumerDispensaryIntegrations_alpineiq_enabled !== void 0 ? _Cart_order_dispensary_consumerDispensaryIntegrations_alpineiq_enabled : false;
    var customerId = User === null || User === void 0 ? void 0 : User.id;
    var dispensaryId = useObserver(function() {
        var _Cart_order_dispensary;
        return (_Cart_order_dispensary = Cart.order.dispensary) === null || _Cart_order_dispensary === void 0 ? void 0 : _Cart_order_dispensary.id;
    });
    var aiqSmsPinTriggerDecision = useObserver(function() {
        var _Cart_order_dispensary_storeSettings, _Cart_order_dispensary, _Cart_order;
        return getAiqSmsPinTriggerDecision({
            isAiqSmsPinTriggerSettingEnabled: isAiqSmsPinTriggerSettingEnabled,
            legacyShouldSkipSmsPin: isSkipSMSSendingEnabled,
            dispensaryId: dispensaryId,
            userId: customerId,
            readiness: Cart.aiqSmsPinTriggerSettingsReadiness,
            aiqSmsPinTriggerBehavior: (_Cart_order = Cart.order) === null || _Cart_order === void 0 ? void 0 : (_Cart_order_dispensary = _Cart_order.dispensary) === null || _Cart_order_dispensary === void 0 ? void 0 : (_Cart_order_dispensary_storeSettings = _Cart_order_dispensary.storeSettings) === null || _Cart_order_dispensary_storeSettings === void 0 ? void 0 : _Cart_order_dispensary_storeSettings.aiqSmsPinTriggerBehavior,
            userEnteredPin: Cart.rewardPin
        });
    });
    var shouldDeferBlankPinOperation = aiqSmsPinTriggerDecision.shouldDeferBlankPinOperation, shouldSkipSmsPin = aiqSmsPinTriggerDecision.shouldSkipSmsPin;
    var pin = Cart.rewardPin || (shouldSkipSmsPin && isAlpineIQEnabled ? 'skip' : '');
    var cartSubtotal = useObserver(function() {
        return Cart.cartSubtotal;
    });
    var shouldSkipQuery = false;
    var birthdayRegex = new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/);
    var isValidBirthday = dob.match(birthdayRegex);
    var isDutchiePOSLoyaltyEnabled = (_Cart_order_dispensary1 = Cart.order.dispensary) === null || _Cart_order_dispensary1 === void 0 ? void 0 : (_Cart_order_dispensary_consumerDispensaryIntegrations1 = _Cart_order_dispensary1.consumerDispensaryIntegrations) === null || _Cart_order_dispensary_consumerDispensaryIntegrations1 === void 0 ? void 0 : (_Cart_order_dispensary_consumerDispensaryIntegrations_dutchieposloyalty = _Cart_order_dispensary_consumerDispensaryIntegrations1.dutchieposloyalty) === null || _Cart_order_dispensary_consumerDispensaryIntegrations_dutchieposloyalty === void 0 ? void 0 : _Cart_order_dispensary_consumerDispensaryIntegrations_dutchieposloyalty.enabled;
    if (!rewardsProgramEnabled(Cart) && !isDutchiePOSLoyaltyEnabled) {
        shouldSkipQuery = true;
    } else if (!isMobilePhone(phoneNumber, 'en-US')) {
        shouldSkipQuery = true;
    } else if (UI.isVariant('kiosk')) {
        shouldSkipQuery = true;
    } else if (!Cart.order.dispensary.id) {
        shouldSkipQuery = true;
    } else if (((_Cart_order1 = Cart.order) === null || _Cart_order1 === void 0 ? void 0 : (_Cart_order_dispensary2 = _Cart_order1.dispensary) === null || _Cart_order_dispensary2 === void 0 ? void 0 : _Cart_order_dispensary2.springbigEnabled) && isValidBirthday === null) {
        shouldSkipQuery = true;
    } else if ((_Cart_rewardAuth = Cart.rewardAuth) === null || _Cart_rewardAuth === void 0 ? void 0 : _Cart_rewardAuth.authTextMessageSent) {
        shouldSkipQuery = true;
    } else if (User.exists && (!dob || dob === '--' || dob === 'Invalid date')) {
        shouldSkipQuery = true;
    }
    var skip = shouldSkipQuery || isDutchiePOSLoyaltyEnabled && !customerId || isAlpineIQEnabled && shouldDeferBlankPinOperation;
    var automaticAiqContext = isAiqSmsPinTriggerSettingEnabled && isAlpineIQEnabled && !Cart.rewardPin ? (_Cart_getAutomaticAiqOneShotContext = Cart.getAutomaticAiqOneShotContext) === null || _Cart_getAutomaticAiqOneShotContext === void 0 ? void 0 : _Cart_getAutomaticAiqOneShotContext.call(Cart, {
        dispensaryId: dispensaryId,
        userId: customerId !== null && customerId !== void 0 ? customerId : null,
        customerId: customerId !== null && customerId !== void 0 ? customerId : null,
        phoneNumber: phoneNumber,
        dob: dob,
        enterpriseId: null,
        isoRegionCode: null,
        pinDecision: pin === 'skip' ? 'skip' : 'blank',
        integration: 'alpineiq',
        origin: 'automatic-aiq'
    }) : undefined;
    var _useApolloQuery = useApolloQuery(getRewardsV2, {
        phoneNumber: phoneNumber,
        dispensaryId: dispensaryId,
        dob: dob,
        pin: pin,
        customerId: customerId,
        cartSubtotal: cartSubtotal
    }, _object_spread({
        fetchPolicy: 'no-cache',
        skip: skip
    }, automaticAiqContext && {
        context: automaticAiqContext
    })), data = _useApolloQuery.data, loading = _useApolloQuery.loading;
    // these changes cause a re-render, so we need to do them in an effect
    // since we do it in a layout effect, it happens synchronously and re-renders
    // that means there's no flicker, although render is called twice
    useLayoutEffect(function() {
        if (!loading && (data === null || data === void 0 ? void 0 : data.getRewardsV2)) {
            var auth = data.getRewardsV2.auth || {};
            if (Cart.rewardPin && !auth.pinConfirmed) {
                return;
            }
            transaction(function() {
                var _data_getRewardsV2_rewards;
                // stale rewards are cleared out by the cart automatically, so we don't want to do that here
                Cart.availableRewards = _.map((_data_getRewardsV2_rewards = data.getRewardsV2.rewards) !== null && _data_getRewardsV2_rewards !== void 0 ? _data_getRewardsV2_rewards : [], function(reward) {
                    return _object_spread_props(_object_spread({}, reward), {
                        // provide reward brand for line item reference
                        brand: data.getRewardsV2.rewardBrand
                    });
                });
                Cart.hasRewardsWallet = data.getRewardsV2.userHasWallet;
                Cart.rewardsBalance = data.getRewardsV2.balance;
                Cart.rewardBrandName = data.getRewardsV2.rewardBrand;
                Cart.rewardAuth = data.getRewardsV2.auth || {};
                Cart.hasCheckedForRewards = true;
            });
        }
    }, [
        data === null || data === void 0 ? void 0 : data.getRewardsV2,
        loading,
        Cart
    ]);
    return data === null || data === void 0 ? void 0 : (_data_getRewardsV2 = data.getRewardsV2) === null || _data_getRewardsV2 === void 0 ? void 0 : _data_getRewardsV2.userHasWallet;
}
